import React from 'react';
import { Link } from 'react-router-dom';

const Finder: React.FC = () => {
  // Kiểm tra token trong localStorage (hoặc sessionStorage nếu bạn dùng session)
  const token = localStorage.getItem('token');

  if (!token) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] py-16 px-4">
        <img
          src="/assets/not-found.png"
          alt="Login required"
          className="w-32 h-32 mb-6 opacity-80"
        />
        <h2 className="text-2xl font-bold mb-2 text-red-500">Bạn cần đăng nhập để sử dụng tính năng này</h2>
        <p className="text-gray-500 mb-6 text-center">Vui lòng đăng nhập để tiếp tục sử dụng Finder.</p>
        <Link
          to="/login"
          className="bg-primary text-white px-6 py-3 rounded-full font-semibold hover:bg-red-700 transition"
        >
          Đăng nhập
        </Link>
      </div>
    );
  }

  // Nếu đã đăng nhập, hiển thị nội dung Finder (placeholder)
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] py-16 px-4">
      <h1 className="text-3xl font-bold mb-4">Finder Page</h1>
      <p className="text-gray-500">Chào mừng bạn đến với Finder!</p>
    </div>
  );
};

export default Finder;
